import React, { useState } from 'react';
import { RefreshCw, Search, Users } from 'lucide-react';
import { StatusBadge } from '../components/StatusBadge';
import { useWorkspace } from '../contexts/WorkspaceContext';
export function Subscriptions() {
  const {
    subscriptions
  } = useWorkspace();
  const [searchQuery, setSearchQuery] = useState('');
  const filteredSubscriptions = subscriptions.filter(sub => sub.email.toLowerCase().includes(searchQuery.toLowerCase()));
  return <div className="space-y-6" data-id="element-1874">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-1875">
        <div className="min-w-0" data-id="element-1876">
          <h1 className="text-2xl font-semibold text-gray-900" data-id="element-1877">
            Subscriptions
          </h1>
          <p className="mt-1 text-sm text-gray-500" data-id="element-1878">
            Manage subscriber status and opt-ins.
          </p>
        </div>
        <div className="relative flex-shrink-0 w-full sm:w-auto" data-id="element-1879">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" data-id="element-1880" />
          <input type="text" placeholder="Search email..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="pl-9 pr-4 py-2 w-full sm:w-64 border border-gray-300 rounded-md text-sm focus:ring-blue-500 focus:border-blue-500" data-id="element-1881" />
        </div>
      </div>

      <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-1882">
        {filteredSubscriptions.length === 0 ? <div className="p-12 text-center" data-id="element-1883">
            <Users className="mx-auto h-12 w-12 text-gray-400" data-id="element-1884" />
            <h3 className="mt-2 text-sm font-semibold text-gray-900" data-id="element-1885">
              No subscriptions found
            </h3>
            <p className="mt-1 text-sm text-gray-500" data-id="element-1886">
              {searchQuery ? 'Try adjusting your search.' : 'Subscribers for this workspace will appear here.'}
            </p>
          </div> : <div className="overflow-x-auto" data-id="element-1887">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-1888">
              <thead className="bg-gray-50" data-id="element-1889">
                <tr data-id="element-1890">
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-1891">
                    Email
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-1892">
                    Newsletter List
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-1893">
                    Status
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-1894">
                    Joined Date
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-1895">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-1896">
                {filteredSubscriptions.map(sub => <tr key={sub.id} className="hover:bg-gray-50" data-id="element-1897">
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-1898">
                      <span className="text-sm font-medium text-gray-900 truncate block max-w-[200px]" data-id="element-1899">
                        {sub.email}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-1900">
                      <span className="text-sm text-gray-500 truncate block max-w-[150px]" data-id="element-1901">
                        {sub.list}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-1902">
                      <StatusBadge status={sub.status} data-id="element-1903" />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1904">
                      {sub.joined}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm" data-id="element-1905">
                      {sub.status === 'pending' && <button className="text-blue-600 hover:text-blue-900 inline-flex items-center gap-1 whitespace-nowrap" data-id="element-1906">
                          <RefreshCw className="h-3 w-3 flex-shrink-0" data-id="element-1907" />
                          <span data-id="element-1908">Resend Opt-in</span>
                        </button>}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>}
      </div>
    </div>;
}